import React, { Component } from "react";
import puzzler01 from "../../../Assets/img/puzzler_1.png";
import puzzler02 from "../../../Assets/img/puzzler_2.png";
import puzzler03 from "../../../Assets/img/puzzler_3.png";
import puzzler04 from "../../../Assets/img/puzzler_4.png";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
 
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 1 // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};

class PuzzlerTalk extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="section-testimonial pt-5 pb-5">
      <div className="container">
        <h3 className="ml-auto mr-auto text-center mb-3">PUZZLER TALK</h3>

        <Carousel responsive={responsive} showDots={this.props.deviceType !== "mobile" ? true : false}  dotListClass="custom-dot-list-style" removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}  infinite={true} autoPlay={this.props.deviceType !== "desktop" ? true : false}
          autoPlaySpeed={4000}>

          <div className="puzzler_talk"> 
          <div className="testimonial-wrapper">
              <div className="testimonial">
                <p className="mb-0 pb-0">
                  I started drinking at this young age cuz I couldn't even solve level 1 of the 
                  warmup edition
                </p>
                <div className="twetter" />
              </div>
              <div className="media pl-2 ml-2">
                <div className="media-left d-flex mr-3">
                  <img src={puzzler01} alt="" />
                </div>
                <div className="media-body">
                  <div className="overview">
                    <div className="name pt-3 text-white">Bad Drunk Baby</div>
                  </div>
                </div>
              </div>
          </div>
          </div> 

          <div className="puzzler_talk">
          <div className="testimonial-wrapper">
              <div className="testimonial">
                <p className="mb-0 pb-0">
                  I literally had the answer with me but spent 3 days on this level thinking that it was silly. Bloody noob.
                </p>
                <div className="twetter" />
              </div>
              <div className="media pl-2 ml-2">
                <div className="media-left d-flex mr-3">
                  <img src={puzzler02} alt="" />
                </div>
                <div className="media-body">
                  <div className="overview">
                    <div className="name pt-3 text-white">
                      Face Palm Patrick
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>


            <div className="puzzler_talk">  
            <div className="testimonial-wrapper">
              <div className="testimonial">
                <p className="mb-0 pb-0">
                  There is no spoon. Likewise, there is no solution to this level. Must pay a visit to the Oracle.
                </p>
                <div className="twetter" />
              </div>
              <div className="media pl-2 ml-2">
                <div className="media-left d-flex mr-3">
                  <img src={puzzler03} alt="" />
                </div>
                <div className="media-body">
                  <div className="overview">
                    <div className="name pt-3 text-white">Matrix Morpheus</div>
                  </div>
                </div>
              </div>
            </div>
            </div>

            <div className="puzzler_talk">
            <div className="testimonial-wrapper">
              <div className="testimonial">
                <p className="mb-0 pb-0">
                  I even forgot my boyfriend while I was engrossed in level 35 for one entire week.
                </p>
                <div className="twetter" />
              </div>
              <div className="media pl-2 ml-2">
                <div className="media-left d-flex mr-3">
                  <img src={puzzler04} alt="" />
                </div>
                <div className="media-body">
                  <div className="overview">
                    <div className="name pt-3 text-white">
                      Overly attached Girlfriend
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>

        </Carousel>


      </div>
    </div>
    );
  }
}
export default PuzzlerTalk;
